import { createAction } from '../../utils/reducer/reducer.utils';
import { AUTH_USER_ACTION_TYPES } from './auth-user.types';

export const setCurrentUser = (user) =>
  createAction(AUTH_USER_ACTION_TYPES.SET_CURRENT_USER, user);

export const resetCurrentUser = () =>
  createAction(AUTH_USER_ACTION_TYPES.RESET_CURRENT_USER);
